// extracted by mini-css-extract-plugin
export default {"editor":"EX-z4h5L8cAZrPduobHGLQ==","range":"ro8geRcoDdH+LuPXcrFgfw==","buttons":"n8aN6q9YOu75BR8o0ghTjQ=="};